import React from 'react'
import {Table} from 'reactstrap'
import moment from 'moment'
import PropTypes from 'prop-types'

const Schedule = ({data}) => {

    if(!data || !data.length) return <p>No Data</p>

    return (
        <Table>
            <thead>
                <tr>
                    <th>Date</th>
                    <th>User</th>
                    <th>Budget</th>
                </tr>
            </thead>
            <tbody>
            {data.map(({start_date, end_date, user, user_project_activities}) => {
                return (
                    <tr>
                        <td>{moment(start_date).format('DD/MM/YYYY HH:mm')} to {moment(end_date).format('DD/MM/YYYY HH:mm')}</td>
                        <td>{user.full_name}</td>
                        <td>{user_project_activities[0].project_activity_budget.project_activity_type.description} - {user_project_activities[0].project_activity_budget.description}</td>
                    </tr>
                )
            })}
            </tbody>
        </Table>
    )

}

Schedule.propTypes = {
    data: PropTypes.array.isRequired
}

export default Schedule